import { IDataUser } from "../interfaces/IUser";

export const checkEmptyObj = (data: IDataUser) => {
  return Object.entries(data).length > 0;
};
